import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { useAuth } from '../../context/ContextData';

const ShareModal = (props) => {
    const { dealerId } = useAuth()
    const url = props.url;
    const title = props.title;

    const [copy, setCopy] = useState();
    const [copySuccess, setCopySuccess] = useState('');
    // const [showTime, setShowTime] = useState(false)

    const copyCodeToClipboard = () => {
        const el = copy
        el.select()
        document.execCommand("copy")
        setCopySuccess('Link copied successfully!')
    }

    return (
        <React.Fragment>
            <Modal show={props.show} onHide={props.setShowShare} className="popupwrapper tw_center mm_model1" centered>

                <Modal.Header closeButton>
                    <Modal.Title>Share</Modal.Title>
                    <div className="text-center ms-4 ps-3">{copySuccess}</div>
                </Modal.Header>

                <Modal.Body className="text-center pb-5 mb-3 px-2">
                    <a target="blank" href={"https://facebook.com/sharer.php?u=" + url + (dealerId && "?dealerId=" + dealerId)} className="">
                        <img src="/assets/icons/facebook_round.svg" alt="facebook" height="45" />
                    </a>

                    <a target="blank" href={"https://twitter.com/intent/tweet?url=" + title + " " + url + (dealerId && "?dealerId=" + dealerId)} className="mx-4">
                        <img src="/assets/icons/twitter_round.svg" alt="facebook" height="45" />
                    </a>

                    <a target="blank" href={"https://wa.me/?text=" + title + " " + url + (dealerId && "?dealerId=" + dealerId)} >
                        <img src="/assets/icons/whatsapp_round.svg" alt="whatsapp" height="45" />
                    </a>
                    {/* <a target="blank" href={"https://www.linkedin.com/shareArticle?mini=true&url=" + url} className="mx-4">
                        <img src="/assets/icons/linkdin_round.svg" alt="linkedin" height="45" />
                    </a> */}

                    <a target="blank" href={"http://pinterest.com/pin/create/link/?url=" + url + (dealerId && "?dealerId=" + dealerId)} className="mx-4">
                        <img src="/assets/icons/pintrest_round.svg" alt="pintrest" height="45" />
                    </a>

                    <label className="mouse" onClick={() => { copyCodeToClipboard(); }} htmlFor="copy">
                        <img src="/assets/icons/copy_round.svg" alt="pintrest" height="45" />
                    </label>

                    {/* <a target="blank" href={"mailto:?body=" + url} className="mr-4">
                            <img src="/assets/icons/facebook_round.svg" alt="facebook" />
                        </a> */}

                    {/* <a target="blank" href={"https://www.instagram.com/sharer.php?u=" + url}>
                            <img src="/assets/icons/whatsapp_round.svg" alt="insta" /> 
                        </a> */}
                    <div className='position-absolute bottom-0'>
                        <input type="text"
                            ref={(el) => setCopy(el)}
                            defaultValue={url + (dealerId && "?dealerId=" + dealerId)}
                            // className="w-75 mt-4 mb-2 d-none"
                            className="opacity-0"
                            id="copy"
                        />
                    </div>
                    {/* <div >
                        <label className="mt-4 mb-2 d-flex">
                            <input type="text"
                                ref={(el) => setCopy(el)}
                                defaultValue={url}
                                className="w-100"
                            />
                            <div className="ms-3 mouse" onClick={copyCodeToClipboard}><img src="/assets/icons/copy.svg" alt="copy" /></div>
                        </label>
                    </div> */}

                </Modal.Body>

            </Modal>
        </React.Fragment>
    )
}

export default ShareModal
